import React from 'react';
import classNames from 'classnames';

import css from './Loader.scss';

const defaultProps = {
	size: 'medium',
	color: '#f9fffe',
	className: '',
};

const Size = {
	small: 'small',
	medium: 'medium',
	large: 'large',
} as const;

type Props = {
	size?: typeof Size[keyof typeof Size];
	color?: string;
	className?: string;
} & typeof defaultProps;

const Loader = ({ size, color, className }: Props) => {
	return <div style={{ borderLeftColor: color }} className={classNames(css.loader, css[size], className)} />;
};

Loader.defaultProps = defaultProps;

Loader.size = Size;

export default Loader;
